import { formatBalance } from 'services/NumberFormatters';
import { fetchDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, PRODUCTID_PATH_PARAM } from 'constants/api';

export const getProductDisplayData = async (product, orgid) => {
    const fetchedProducts = await fetchDataRequest('productDisplayData', [ORGID_PATH_PARAM, PRODUCTID_PATH_PARAM], [orgid, product?.id]) || [];
    return {
        id: product?.id ? product?.id : 0,
        name: product?.name ? product?.name : 'No name specified',
        description: product?.description ? product?.description : 'No description specified',
        valueStream: fetchedProducts?.valueStreamName ? fetchedProducts?.valueStreamName : 'No value stream selected',
        manager: fetchedProducts?.managerName ? fetchedProducts?.managerName : 'No manager selected',
        businessUnit: fetchedProducts?.businessUnitName ? fetchedProducts?.businessUnitName : 'No business unit selected',
        fyBudget: product?.fyBudget ? formatBalance(product?.fyBudget) : formatBalance(0),
        productType: product?.productType ? product?.productType : 'No product type selected',

    };
};

// temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)
export const getMockDrillDownData = () => {
    return [{ id: '2578cb65923bb7ba0845014820190617', name: 'fake valueStream number 1', description: 'description number 1' }, { id: '9876cb65923bb7ba0845014820190617', name: 'fake valueStream number 2', description: 'description number 2' }];
};





// WEBPACK FOOTER //
// ./services/productService.js